import React, { useState } from "react";
import styles from "./GalleriesListSection.module.scss";
import SearchIcon from "components/svgs/SearchIcon";
import CloseIcon from "components/svgs/CloseIcon";

const GalleriesListSection = () => {
  const [openAlphabeticDropdown, setOpenAlphabeticDropdown] = useState(false);
  const [openCountriesDropdown, setOpenCountriesDropdown] = useState(false);

  return (
    <div className={styles.galleriesListSection}>
      <div className={styles.galleriesFiltration}>
        <div className={styles.alphabetic}>
          <div
            className={styles.alphabeticTitle}
            onClick={() => setOpenAlphabeticDropdown(true)}
          >
            Galleries Alphabetic
          </div>
          {openAlphabeticDropdown ? (
            <div className={styles.alphabeticDropdown}>
              <div
                className={styles.close}
                onClick={() => setOpenAlphabeticDropdown(false)}
              >
                <CloseIcon />
              </div>

              <ul>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
                <li>Name Of The Gallery</li>
              </ul>
            </div>
          ) : null}
        </div>
        <div className={styles.searchBy}>
          <input
            type="text"
            placeholder="Serach by Gallery Name or by Country"
          />
          <SearchIcon />
        </div>
        <div className={styles.countries}>
          <div
            className={styles.countriesTitle}
            onClick={() => setOpenCountriesDropdown(true)}
          >
            Countries
          </div>
          {openCountriesDropdown ? (
            <div className={styles.countriesDropdown}>
              <div
                className={styles.close}
                onClick={() => setOpenCountriesDropdown(false)}
              >
                <CloseIcon />
              </div>

              <ul>
                <li>Artsakh</li>
                <li>Armenia</li>
                <li>France</li>
                <li>Russia</li>
                <li>USA</li>
                <li>Albania</li>
                <li>Albania</li>
                <li>Albania</li>
                <li>Albania</li>
                <li>Albania</li>
                <li>Albania</li>
                <li>Albania</li>
                <li>Albania</li>
                <li>Albania</li>
              </ul>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default GalleriesListSection;
